import React from 'react';

export const Cookie = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, ref: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        viewBox="0 0 365.152 365.152"
        width="512"
        height="512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g>
          <path
            style={{ fill: '#B27214' }}
            d="M263.039,175.165c14.81,0,26.81,12,26.81,26.81c0,14.8-12,26.81-26.81,26.81   c-14.8,0-26.81-12.01-26.81-26.81C236.229,187.165,248.239,175.165,263.039,175.165z"
          />
          <path
            style={{ fill: '#B27214' }}
            d="M133.739,228.785c12.19,0,22.07,9.88,22.07,22.07c0,12.2-9.88,22.08-22.07,22.08   c-12.2,0-22.08-9.88-22.08-22.08C111.659,238.665,121.539,228.785,133.739,228.785z"
          />
          <path
            style={{ fill: '#B27214' }}
            d="M143.989,94.745c10.01,0,18.13,8.12,18.13,18.14c0,10.01-8.12,18.13-18.13,18.13   c-10.02,0-18.14-8.12-18.14-18.13C125.849,102.865,133.969,94.745,143.989,94.745z"
          />
          <path
            style={{ fill: '#F7B239' }}
            d="M182.579,7.495c96.69,0,175.07,78.39,175.07,175.08s-78.38,175.08-175.07,175.08   c-96.7,0-175.08-78.39-175.08-175.08S85.879,7.495,182.579,7.495z M289.849,201.975c0-14.81-12-26.81-26.81-26.81   c-14.8,0-26.81,12-26.81,26.81c0,14.8,12.01,26.81,26.81,26.81C277.849,228.785,289.849,216.775,289.849,201.975z M162.119,112.885   c0-10.02-8.12-18.14-18.13-18.14c-10.02,0-18.14,8.12-18.14,18.14c0,10.01,8.12,18.13,18.14,18.13   C153.999,131.015,162.119,122.895,162.119,112.885z M155.809,250.855c0-12.19-9.88-22.07-22.07-22.07   c-12.2,0-22.08,9.88-22.08,22.07c0,12.2,9.88,22.08,22.08,22.08C145.929,272.935,155.809,263.055,155.809,250.855z"
          />
          <g>
            <path
              style={{ fill: '#E09B2D' }}
              d="M92.499,182.575c0-82.032,56.421-150.881,132.578-169.874c-13.607-3.394-27.84-5.206-42.498-5.206    c-96.7,0-175.08,78.39-175.08,175.08s78.38,175.08,175.08,175.08c14.658,0,28.891-1.812,42.498-5.206    C148.92,333.457,92.499,264.607,92.499,182.575z"
            />
          </g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M322.677,249.217c-0.977,0-1.968-0.191-2.923-0.596c-3.814-1.616-5.596-6.018-3.979-9.832   c7.548-17.815,11.375-36.729,11.375-56.214c0-53.119-29.117-101.879-75.988-127.251c-3.643-1.972-4.997-6.523-3.025-10.166   c1.972-3.643,6.522-4.998,10.166-3.025c51.719,27.996,83.848,81.811,83.848,140.442c0,21.507-4.228,42.389-12.564,62.065   C328.374,247.5,325.598,249.217,322.677,249.217z"
          />
          <circle style={{ fill: '#FFFFFF' }} cx="224.212" cy="36.517" r="7.5" />
          <g>
            <path
              style={{ fill: '#333333' }}
              d="M182.576,0C81.903,0,0,81.903,0,182.576s81.903,182.576,182.576,182.576    s182.576-81.903,182.576-182.576S283.249,0,182.576,0z M182.576,350.152C90.175,350.152,15,274.978,15,182.576    S90.175,15,182.576,15s167.576,75.174,167.576,167.576S274.978,350.152,182.576,350.152z"
            />
            <path
              style={{ fill: '#333333' }}
              d="M143.984,87.247c-14.135,0-25.634,11.5-25.634,25.634s11.499,25.634,25.634,25.634    s25.635-11.5,25.635-25.634S158.119,87.247,143.984,87.247z M143.984,123.515c-5.863,0-10.634-4.771-10.634-10.634    s4.771-10.634,10.634-10.634c5.864,0,10.635,4.771,10.635,10.634S149.849,123.515,143.984,123.515z"
            />
            <path
              style={{ fill: '#333333' }}
              d="M263.039,167.667c-18.917,0-34.307,15.39-34.307,34.307s15.39,34.307,34.307,34.307    s34.308-15.39,34.308-34.307S281.956,167.667,263.039,167.667z M263.039,221.282c-10.646,0-19.307-8.661-19.307-19.307    s8.661-19.307,19.307-19.307c10.646,0,19.308,8.661,19.308,19.307S273.686,221.282,263.039,221.282z"
            />
            <path
              style={{ fill: '#333333' }}
              d="M133.735,221.282c-16.309,0-29.576,13.268-29.576,29.576s13.268,29.576,29.576,29.576    s29.576-13.268,29.576-29.576S150.044,221.282,133.735,221.282z M133.735,265.434c-8.037,0-14.576-6.539-14.576-14.576    s6.539-14.576,14.576-14.576s14.576,6.539,14.576,14.576S141.772,265.434,133.735,265.434z"
            />
            <circle style={{ fill: '#333333' }} cx="256.729" cy="102.635" r="7.5" />
            <circle style={{ fill: '#333333' }} cx="89.579" cy="167.285" r="7.5" />
            <circle style={{ fill: '#333333' }} cx="206.269" cy="269.785" r="7.5" />
          </g>
        </g>
      </svg>
    );
  },
);
